import React, { useState, useEffect, useRef } from "react";
import ReactHtmlParser from "html-react-parser";
import moment from "moment";
import {
  BASE_URL,
  GET_SINGLE_PBS_PLANS_URL,
} from "../../env";
import {
  getRecords,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
  deleteRecords,
  catchAsync,
} from "../../helper/helper";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/layouts/Layout";
import UserDetailReview from "../../components/user-detail/UserDetailReview";
import IsCompleted from "./IsCompleted";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import '@progress/kendo-theme-default/dist/all.css';

function ViewPbsPlan() {
  if (localStorage.getItem('pbsPlanDetail')) {
    localStorage.removeItem('pbsPlanDetail');
  }
  const navigate = useNavigate();

  // check if pbs plan id exists or not 
  const localStoragepbsPlan = localStorage.getItem("pbsPlanDetailId");
  let parsedPbsPlan = null;

  if (localStoragepbsPlan === null) {
    navigate("/pbs-plans");
  } else {
    try {
      parsedPbsPlan = JSON.parse(localStoragepbsPlan);
    } catch (error) {
      console.error("Invalid JSON in localStorage", error);
      navigate("/pbs-plans");
    }
  }


  // Get user record
  const storedUserDetails = localStorage.getItem("profileUserDetails");
  const userData = storedUserDetails ? JSON.parse(storedUserDetails) : null;

  // PBS Plan Detail State
  const [pbsPlansDetail, setPbsPlansDetail] = useState(null);
  const [pbsPlansHistoryDetail, setPbsPlansHistoryDetail] = useState(null);
  console.log("🚀 ~ ViewPbsPlan ~ pbsPlansHistoryDetail:", pbsPlansHistoryDetail)
  // console.log("🚀 ~ ViewPbsPlan ~ pbsPlansDetail:", pbsPlansDetail)
  const [isReviewed, setIsReviewed] = useState(false);

  // console.log("🚀 ~ ViewPbsPlan ~ userData:", userData)
  // const apiQuery = {
  //   pbsId: userData?._id
  // }


  // Getting records from DB
  const processFetchRecords = (method, data) => {
    if (method === "get" && data?.status === isSuccess) {
      const pbsPlanList = data?.data?.pbs;
      const pbsPlanHistoryList = data?.data?.pbsHistory;
      setPbsPlansDetail(pbsPlanList);
      setPbsPlansHistoryDetail(pbsPlanHistoryList);
    }

  };

  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_SINGLE_PBS_PLANS_URL, { pbsId: parsedPbsPlan, });
    // console.log("🚀 ~ ViewPbsPlan ~ response:", response)
    processFetchRecords("get", response);
  });

  useEffect(() => {
    if (parsedPbsPlan) {
      fetchAllRecords();
    }
  }, [parsedPbsPlan]);
  useEffect(() => {
    fetchAllRecords();
  }, [isReviewed]);



  // useEffect(() => {
  //   const plan = parsedPbsPlan;

  //   // if (!plan) {
  //   //   navigate("/pbs-plans");
  //   //   return;
  //   // }

  //   try {
  //     setPbsPlansDetail(parsedPbsPlan);
  //   } catch (err) {
  //     console.error("Invalid JSON in localStorage:", err);
  //     navigate("/pbs-plans");
  //   }
  // }, [navigate]);

  // Safe HTML parser
  const parseHTML = (html) => ReactHtmlParser(html || "");

  const handleEditPBSPlans = (item, url) => {
    localStorage.setItem(
      "pbsPlanDetail",
      JSON.stringify(item)
    );
    navigate(url);
  };

  //Export to pdf
  const pdfExportComponent = useRef(null);
  const [showInPrint, setShowInPrint] = useState(false);
  const exportPDF = () => {
    if (pdfExportComponent.current) {
      setShowInPrint(true);
      setTimeout(() => {
        pdfExportComponent.current.save();
      }, 100);
      setTimeout(() => {
        setShowInPrint(false);
      }, 1000);


    }
  };

  // ⏳ Prevent rendering until data is loaded
  if (!pbsPlansDetail) {
    return (
      <Layout pageTitleText="PBS Plans">
        <p className="text-center mt-5">Loading...</p>
      </Layout>
    );
  }



  return (
    <>

      <Layout pageTitleText="PBS Plans">
        {/* {parsedPbsPlan} */}
        <UserDetailReview
          getUserRecord={userData}
          avatarActionButtons={false}
          viewNotes={false}
          profileDetail={false}
          horizontalDetail={true}
          launchVideoButtons={true}
        />

        <div className="viewEditorWrapper">
          <div className="mainContent mt-3 pt-4">
            {/* TOP SECTION */}
            <header className="mainContentHeader">
              <div className="usersNameInfo">
                <div className="contentBox">
                  <span className="isReviewed">
                    <IsCompleted
                      isReviewed={pbsPlansDetail?.isReviewed === true}
                      setIsReviewed={setIsReviewed}
                      individualQueryData={pbsPlansDetail}
                    />
                  </span>
                </div>
              </div>
              <div className="actionButtons">
                <span
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => navigate("/pbs-plans-history", { state: pbsPlansHistoryDetail })}
                >
                  View PBS Plan History
                </span>
              </div>
            </header>

            {/* USER INFO BAR */}
            <header className={`mainContentHeader ${showInPrint ? "hiddenDiv" : ""}`}>
              <div className="usersNameInfo">
                <span className="userImage">
                  <img
                    src={`${BASE_URL}${pbsPlansDetail?.staffId?.profile_picture_url}`}
                    alt={pbsPlansDetail?.staffId?.name}
                  />
                </span>
                <div className="contentBox">
                  <p className="m-0">
                    <strong>{pbsPlansDetail?.staffId?.name}</strong>
                    <small>
                      {moment(pbsPlansDetail?.updatedAt).format(
                        "DD/MM/YYYY / hh:mm:ss A"
                      )}
                    </small>
                    <small>
                      Due Date:{" "}
                      {moment(pbsPlansDetail?.completionDate).format(
                        "DD/MM/YYYY"
                      )}
                    </small>
                  </p>
                </div>
              </div>

              <div>
                <span className="btn btn-sm btn-outline-primary"
                  onClick={exportPDF}
                >Export to PDF</span>

                &nbsp;
                <span
                  className="btn btn-sm btn-primary"
                  onClick={() => navigate("/pbs-plans")}
                >
                  Back to PBS Plans
                </span>

                &nbsp;

                <span
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleEditPBSPlans(pbsPlansDetail, "/edit-plans")}
                >
                  Edit
                </span>
              </div>
            </header>

            {/* CONTENT SECTIONS */}

            <PDFExport
              ref={pdfExportComponent}
              paperSize={["900pt", "900pt"]}
              margin={20}
              fileName={`PBS Plan`}
            >

              <header className={`mainContentHeader ${showInPrint ? "" : "hiddenDiv"}`}>
                <div className="usersNameInfo">
                  <span className={`userImage ${showInPrint ? "hiddenDiv" : ""}`}>
                    <img
                      src={`${BASE_URL}${pbsPlansDetail?.staffId?.profile_picture_url}`}
                      alt={pbsPlansDetail?.staffId?.name}
                    />
                  </span>
                  <div className="contentBox">
                    <p className="m-0">
                      <strong>{pbsPlansDetail?.staffId?.name}</strong>
                      <small>
                        {moment(pbsPlansDetail?.updatedAt).format(
                          "DD/MM/YYYY / hh:mm:ss A"
                        )}
                      </small>
                      <small>
                        Due Date:{" "}
                        {moment(pbsPlansDetail?.completionDate).format(
                          "DD/MM/YYYY"
                        )}
                      </small>
                    </p>
                  </div>
                </div>
                <div className="usersNameInfo">
                  <div className="contentBox">
                    <span className="isReviewed">
                      <IsCompleted
                        isReviewed={pbsPlansDetail?.isReviewed === true}
                        setIsReviewed={setIsReviewed}
                        individualQueryData={pbsPlansDetail}
                        pdfExport={true}
                      />
                    </span>
                  </div>
                </div>

              </header>

              <div className="viewEditorContent">

                {/* All about me (TITLE) */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobpBg">
                      <h3>All about me</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.aboutPlan)}
                    </div>
                  </div>
                </div>



                {/* Aim of Positive Behaviour Support Plan */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobpBg">
                      <h3>Aim of Positive Behaviour Support Plan</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.aimOfPositiveBehaviourPlan)}
                    </div>
                  </div>
                </div>



                {/* Setting Events (Slow Triggers) */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobpBg">
                      <h3>Setting Events (Slow Triggers)</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.settingEventsPlan)}
                    </div>
                  </div>
                </div>



                {/* Discriminative Stimuli (Fast Triggers) */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobpBg">
                      <h3>Discriminative Stimuli (Fast Triggers)</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.discriminativeStimuliPlan)}
                    </div>
                  </div>
                </div>



                {/* Behaviour of Concern */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobpBg">
                      <h3>Behaviour of Concern</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.behaviourOfConcernPlan)}
                    </div>
                  </div>
                </div>




                {/* Management of Behavioural Presentation */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark mobTitle border-bottom-0">
                      <h3>Management of Behavioural Presentation<br />
                        Primary Prevention – Proactive</h3>
                    </header>
                    <header className="alert alert-dark mobpBg">
                      <h3>When I am calm and at baseline</h3>
                    </header>
                    <div className="mobpContentBg p-3">
                      {parseHTML(pbsPlansDetail?.managementOfBehaviorPlan)}
                    </div>
                  </div>
                </div>




                {/* Reducing likelihood of target behaviour occurring  */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark cleanBg">
                      <h3>Reducing likelihood of target behaviour occurring </h3>
                    </header>
                    <div className="cleanBg p-3">
                      {parseHTML(pbsPlansDetail?.reducingLikeliHood)}
                    </div>
                  </div>
                </div>


                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark spBg">
                      <h3>Secondary Prevention<br />
                        Indicators I am moving away from baseline</h3>
                    </header>
                    <div className="spContentBg p-3">
                      {parseHTML(pbsPlansDetail?.secondaryPrevention)}
                    </div>
                  </div>
                </div>


                {/* Things to do when I display amber behaviours  */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark cleanBg">
                      <h3>Things to do when I display amber behaviours</h3>
                    </header>
                    <div className="cleanBg p-3">
                      {parseHTML(pbsPlansDetail?.thingsToDisplayAmberBehavior)}
                    </div>
                  </div>
                </div>

                {/* Reactive Strategies */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark rsBg">
                      <h3>Reactive Strategies<br />
                        Behaviours displayed in crisis include</h3>
                    </header>
                    <div className="rsContentBg p-3">
                      {parseHTML(pbsPlansDetail?.reactiveStartegies)}
                    </div>
                  </div>
                </div>

                {/* Things to try when I am in crisis  */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark cleanBg">
                      <h3>Things to try when I am in crisis</h3>
                    </header>
                    <div className="cleanBg p-3">
                      {parseHTML(pbsPlansDetail?.postThingsToTry)}
                    </div>
                  </div>
                </div>

                {/* Post Incident Support- Recovery */}
                <div className="sectionWrapper">
                  <div className="sectionContent pbsFieldWrapper">
                    <header className="alert alert-dark pisrBg">
                      <h3>Post Incident Support- Recovery</h3>
                    </header>
                    <div className="pisrContentBg p-3">
                      {ReactHtmlParser(pbsPlansDetail?.postIncidentSupport)}
                    </div>
                  </div>
                </div>

              </div>
            </PDFExport>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default ViewPbsPlan;
